
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1u7vc", function(module, exports) {

$parcel$export(module.exports, "guessTimezone", () => $114e6991d5399cc8$export$d206b0d0f3a34d2d);

var $2DMbv = parcelRequire("2DMbv");

var $k4PPW = parcelRequire("k4PPW");
const $114e6991d5399cc8$var$timezones = window.Intl.supportedValuesOf("timeZone");
// https://github.com/eggert/tz/blob/main/etcetera
const $114e6991d5399cc8$var$TZ_ETC = "Etc/GMT";
function $114e6991d5399cc8$export$d206b0d0f3a34d2d(input, { strict: strict } = {}) {
    const inputLowerCase = input.toLowerCase();
    if (inputLowerCase === "factory") // https://github.com/eggert/tz/blob/main/factory
    return null;
    try {
        const directMatch = (0, $2DMbv.Temporal).TimeZone.from(input);
        if (directMatch.id === $114e6991d5399cc8$var$TZ_ETC) return (0, $2DMbv.Temporal).TimeZone.from("UTC");
        if (directMatch.id.startsWith($114e6991d5399cc8$var$TZ_ETC)) {
            const reverseOffset = directMatch.id.slice($114e6991d5399cc8$var$TZ_ETC.length);
            const offset = reverseOffset.startsWith("-") ? `+${reverseOffset.length === 2 ? "0" : ""}${reverseOffset.slice(1)}` : `-${reverseOffset.length === 2 ? "0" : ""}${reverseOffset.slice(1)}`;
            return (0, $2DMbv.Temporal).TimeZone.from(offset);
        }
        return directMatch;
    } catch (_e) {
    //
    }
    if (inputLowerCase === "europe/kyiv" || inputLowerCase === "kyiv") return (0, $2DMbv.Temporal).TimeZone.from("Europe/Kiev");
    if (inputLowerCase === "utc" || inputLowerCase === "gmt") return (0, $2DMbv.Temporal).TimeZone.from("UTC");
    if (inputLowerCase.match(/^(utc|gmt)?[+-][0-1]?[0-9](:[0-5][0-9])?$/)) {
        // ^- RELATIVE_UTC_ID_REGEX
        const offset = inputLowerCase.startsWith("utc") || inputLowerCase.startsWith("gmt") ? inputLowerCase.slice(3) : inputLowerCase;
        const strictOffset = offset.match((0, $k4PPW.STRICT_RELATIVE_UTC_ID_REGEX)) ? offset : `${offset[0]}0${offset.slice(1)}`;
        if (strictOffset === "+00" || strictOffset === "+00:00" || strictOffset === "-00" || strictOffset === "-00:00") return (0, $2DMbv.Temporal).TimeZone.from("UTC");
        try {
            return (0, $2DMbv.Temporal).TimeZone.from(strictOffset);
        } catch (_e) {
        //
        }
    }
    const guessTimezones = strict ? $114e6991d5399cc8$var$timezones.filter((v)=>{
        const tzLowerCase = v.toLowerCase();
        if (tzLowerCase === inputLowerCase) return true;
        const parts = tzLowerCase.split("/");
        const last = parts[parts.length - 1];
        return inputLowerCase === last;
    }) : $114e6991d5399cc8$var$timezones.filter((v)=>v.toLowerCase().includes(inputLowerCase));
    if (guessTimezones.length === 1) return (0, $2DMbv.Temporal).TimeZone.from(guessTimezones[0]);
    return null;
}

});
parcelRegister("k4PPW", function(module, exports) {

$parcel$export(module.exports, "STRICT_RELATIVE_UTC_ID_REGEX", () => $e9dc6411e0bd32b2$export$5602ec2a8fd224bb);
$parcel$export(module.exports, "getLocationFromTimezone", () => $e9dc6411e0bd32b2$export$b1e59166561b2dc1);
$parcel$export(module.exports, "getPathnameFromTimezone", () => $e9dc6411e0bd32b2$export$86df7c97980593dd);
const $e9dc6411e0bd32b2$export$571988de172797e5 = /^[+-][0-1]?[0-9](:[0-5][0-9])?$/;
const $e9dc6411e0bd32b2$export$5602ec2a8fd224bb = /^[+-][0-1][0-9](:[0-5][0-9])?$/;
function $e9dc6411e0bd32b2$export$b1e59166561b2dc1(tz) {
    if (tz.toString() === "UTC") return "UTC";
    if (tz.toString().match($e9dc6411e0bd32b2$export$5602ec2a8fd224bb)) return "UTC" + tz.toString().replace(/^([+-])0?(1?[0-9]):00$/, "$1$2");
    const parts = tz.toString().split("/");
    const location = parts.length === 3 ? `${parts[1]}/${parts[2]}` : parts[1];
    if (!location) // fallback for invalidly saved timezones
    return tz.toString();
    if (location === "Kiev") return "Kyiv";
    else if (location === "Sao_Paulo") return "S\xe3o Paulo";
    return location.replace(/^St_/, "St. ").replace(/_/g, " ");
}
function $e9dc6411e0bd32b2$export$86df7c97980593dd(tz) {
    if (tz.toString() === "unix") return "/unix";
    if (tz.toString() === "UTC") return "/UTC";
    if (tz.toString().match($e9dc6411e0bd32b2$export$5602ec2a8fd224bb)) return "/UTC" + tz.toString().replace(/^([+-])0?(1?[0-9]):00$/, "$1$2");
    if (tz.toString() === "Europe/Kiev") return "/Europe/Kyiv";
    return `/${tz}`;
}

});



var $aJa0n = parcelRequire("aJa0n");
var $955ca6abf4bcc751$var$k = class {
    type = 3;
    name = "";
    prefix = "";
    value = "";
    suffix = "";
    modifier = 3;
    constructor(t, r, n, o, c, l){
        this.type = t, this.name = r, this.prefix = n, this.value = o, this.suffix = c, this.modifier = l;
    }
    hasCustomName() {
        return this.name !== "" && typeof this.name != "number";
    }
}, $955ca6abf4bcc751$var$Pe = /[$_\p{ID_Start}]/u, $955ca6abf4bcc751$var$Se = /[$_\u200C\u200D\p{ID_Continue}]/u, $955ca6abf4bcc751$var$M = ".*";
function $955ca6abf4bcc751$var$ke(e, t) {
    return (t ? /^[\x00-\xFF]*$/ : /^[\x00-\x7F]*$/).test(e);
}
function $955ca6abf4bcc751$var$v(e, t = !1) {
    let r = [], n = 0;
    for(; n < e.length;){
        let o = e[n], c = function(l) {
            if (!t) throw new TypeError(l);
            r.push({
                type: "INVALID_CHAR",
                index: n,
                value: e[n++]
            });
        };
        if (o === "*") {
            r.push({
                type: "ASTERISK",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (o === "+" || o === "?") {
            r.push({
                type: "OTHER_MODIFIER",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (o === "\\") {
            r.push({
                type: "ESCAPED_CHAR",
                index: n++,
                value: e[n++]
            });
            continue;
        }
        if (o === "{") {
            r.push({
                type: "OPEN",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (o === "}") {
            r.push({
                type: "CLOSE",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (o === ":") {
            let l = "", s = n + 1;
            for(; s < e.length;){
                let i = e.substr(s, 1);
                if (s === n + 1 && $955ca6abf4bcc751$var$Pe.test(i) || s !== n + 1 && $955ca6abf4bcc751$var$Se.test(i)) {
                    l += e[s++];
                    continue;
                }
                break;
            }
            if (!l) {
                c(`Missing parameter name at ${n}`);
                continue;
            }
            r.push({
                type: "NAME",
                index: n,
                value: l
            }), n = s;
            continue;
        }
        if (o === "(") {
            let l = 1, s = "", i = n + 1, a = !1;
            if (e[i] === "?") {
                c(`Pattern cannot start with "?" at ${i}`);
                continue;
            }
            for(; i < e.length;){
                if (!$955ca6abf4bcc751$var$ke(e[i], !1)) {
                    c(`Invalid character '${e[i]}' at ${i}.`), a = !0;
                    break;
                }
                if (e[i] === "\\") {
                    s += e[i++] + e[i++];
                    continue;
                }
                if (e[i] === ")") {
                    if (l--, l === 0) {
                        i++;
                        break;
                    }
                } else if (e[i] === "(" && (l++, e[i + 1] !== "?")) {
                    c(`Capturing groups are not allowed at ${i}`), a = !0;
                    break;
                }
                s += e[i++];
            }
            if (a) continue;
            if (l) {
                c(`Unbalanced pattern at ${n}`);
                continue;
            }
            if (!s) {
                c(`Missing pattern at ${n}`);
                continue;
            }
            r.push({
                type: "REGEX",
                index: n,
                value: s
            }), n = i;
            continue;
        }
        r.push({
            type: "CHAR",
            index: n,
            value: e[n++]
        });
    }
    return r.push({
        type: "END",
        index: n,
        value: ""
    }), r;
}
function $955ca6abf4bcc751$var$D(e, t = {}) {
    let r = $955ca6abf4bcc751$var$v(e);
    t.delimiter ??= "/#?", t.prefixes ??= "./";
    let n = `[^${$955ca6abf4bcc751$var$x(t.delimiter)}]+?`, o = [], c = 0, l = 0, s = "", i = new Set, a = (f)=>{
        if (l < r.length && r[l].type === f) return r[l++].value;
    }, h = ()=>a("OTHER_MODIFIER") ?? a("ASTERISK"), p = (f)=>{
        let u = a(f);
        if (u !== void 0) return u;
        let { type: d, index: T } = r[l];
        throw new TypeError(`Unexpected ${d} at ${T}, expected ${f}`);
    }, O = ()=>{
        let f = "", u;
        for(; u = a("CHAR") ?? a("ESCAPED_CHAR");)f += u;
        return f;
    }, xe = (f)=>f, L = t.encodePart || xe, I = "", H = (f)=>{
        I += f;
    }, $ = ()=>{
        I.length && (o.push(new $955ca6abf4bcc751$var$k(3, "", "", L(I), "", 3)), I = "");
    }, G = (f, u, d, T, Y)=>{
        let g = 3;
        switch(Y){
            case "?":
                g = 1;
                break;
            case "*":
                g = 0;
                break;
            case "+":
                g = 2;
                break;
        }
        if (!u && !d && g === 3) {
            H(f);
            return;
        }
        if ($(), !u && !d) {
            if (!f) return;
            o.push(new $955ca6abf4bcc751$var$k(3, "", "", L(f), "", g));
            return;
        }
        let m;
        d ? d === "*" ? m = $955ca6abf4bcc751$var$M : m = d : m = n;
        let R = 2;
        m === n ? (R = 1, m = "") : m === $955ca6abf4bcc751$var$M && (R = 0, m = "");
        let S;
        if (u ? S = u : d && (S = c++), i.has(S)) throw new TypeError(`Duplicate name '${S}'.`);
        i.add(S), o.push(new $955ca6abf4bcc751$var$k(R, S, L(f), m, L(T), g));
    };
    for(; l < r.length;){
        let f = a("CHAR"), u = a("NAME"), d = a("REGEX");
        if (!u && !d && (d = a("ASTERISK")), u || d) {
            let g = f ?? "";
            t.prefixes.indexOf(g) === -1 && (H(g), g = ""), $();
            let m = h();
            G(g, u, d, "", m);
            continue;
        }
        let T = f ?? a("ESCAPED_CHAR");
        if (T) {
            H(T);
            continue;
        }
        if (a("OPEN")) {
            let g = O(), m = a("NAME"), R = a("REGEX");
            !m && !R && (R = a("ASTERISK"));
            let S = O();
            p("CLOSE");
            let be = h();
            G(g, m, R, S, be);
            continue;
        }
        $(), p("END");
    }
    return o;
}
function $955ca6abf4bcc751$var$x(e) {
    return e.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
function $955ca6abf4bcc751$var$X(e) {
    return e && e.ignoreCase ? "ui" : "u";
}
function $955ca6abf4bcc751$var$Z(e, t, r) {
    return $955ca6abf4bcc751$var$F($955ca6abf4bcc751$var$D(e, r), t, r);
}
function $955ca6abf4bcc751$var$y(e) {
    switch(e){
        case 0:
            return "*";
        case 1:
            return "?";
        case 2:
            return "+";
        case 3:
            return "";
    }
}
function $955ca6abf4bcc751$var$F(e, t, r = {}) {
    r.delimiter ??= "/#?", r.prefixes ??= "./", r.sensitive ??= !1, r.strict ??= !1, r.end ??= !0, r.start ??= !0, r.endsWith = "";
    let n = r.start ? "^" : "";
    for (let s of e){
        if (s.type === 3) {
            s.modifier === 3 ? n += $955ca6abf4bcc751$var$x(s.value) : n += `(?:${$955ca6abf4bcc751$var$x(s.value)})${$955ca6abf4bcc751$var$y(s.modifier)}`;
            continue;
        }
        t && t.push(s.name);
        let i = `[^${$955ca6abf4bcc751$var$x(r.delimiter)}]+?`, a = s.value;
        if (s.type === 1 ? a = i : s.type === 0 && (a = $955ca6abf4bcc751$var$M), !s.prefix.length && !s.suffix.length) {
            s.modifier === 3 || s.modifier === 1 ? n += `(${a})${$955ca6abf4bcc751$var$y(s.modifier)}` : n += `((?:${a})${$955ca6abf4bcc751$var$y(s.modifier)})`;
            continue;
        }
        if (s.modifier === 3 || s.modifier === 1) {
            n += `(?:${$955ca6abf4bcc751$var$x(s.prefix)}(${a})${$955ca6abf4bcc751$var$x(s.suffix)})`, n += $955ca6abf4bcc751$var$y(s.modifier);
            continue;
        }
        n += `(?:${$955ca6abf4bcc751$var$x(s.prefix)}`, n += `((?:${a})(?:`, n += $955ca6abf4bcc751$var$x(s.suffix), n += $955ca6abf4bcc751$var$x(s.prefix), n += `(?:${a}))*)${$955ca6abf4bcc751$var$x(s.suffix)})`, s.modifier === 0 && (n += "?");
    }
    let o = `[${$955ca6abf4bcc751$var$x(r.endsWith)}]|$`, c = `[${$955ca6abf4bcc751$var$x(r.delimiter)}]`;
    if (r.end) return r.strict || (n += `${c}?`), r.endsWith.length ? n += `(?=${o})` : n += "$", new RegExp(n, $955ca6abf4bcc751$var$X(r));
    r.strict || (n += `(?:${c}(?=${o}))?`);
    let l = !1;
    if (e.length) {
        let s = e[e.length - 1];
        s.type === 3 && s.modifier === 3 && (l = r.delimiter.indexOf(s) > -1);
    }
    return l || (n += `(?=${c}|${o})`), new RegExp(n, $955ca6abf4bcc751$var$X(r));
}
var $955ca6abf4bcc751$var$b = {
    delimiter: "",
    prefixes: "",
    sensitive: !0,
    strict: !0
}, $955ca6abf4bcc751$var$B = {
    delimiter: ".",
    prefixes: "",
    sensitive: !0,
    strict: !0
}, $955ca6abf4bcc751$var$q = {
    delimiter: "/",
    prefixes: "/",
    sensitive: !0,
    strict: !0
};
function $955ca6abf4bcc751$var$J(e, t) {
    return e.length ? e[0] === "/" ? !0 : !t || e.length < 2 ? !1 : (e[0] == "\\" || e[0] == "{") && e[1] == "/" : !1;
}
function $955ca6abf4bcc751$var$Q(e, t) {
    return e.startsWith(t) ? e.substring(t.length, e.length) : e;
}
function $955ca6abf4bcc751$var$Ee(e, t) {
    return e.endsWith(t) ? e.substr(0, e.length - t.length) : e;
}
function $955ca6abf4bcc751$var$W(e) {
    return !e || e.length < 2 ? !1 : e[0] === "[" || (e[0] === "\\" || e[0] === "{") && e[1] === "[";
}
var $955ca6abf4bcc751$var$ee = [
    "ftp",
    "file",
    "http",
    "https",
    "ws",
    "wss"
];
function $955ca6abf4bcc751$var$N(e) {
    if (!e) return !0;
    for (let t of $955ca6abf4bcc751$var$ee)if (e.test(t)) return !0;
    return !1;
}
function $955ca6abf4bcc751$var$te(e, t) {
    if (e = $955ca6abf4bcc751$var$Q(e, "#"), t || e === "") return e;
    let r = new URL("https://example.com");
    return r.hash = e, r.hash ? r.hash.substring(1, r.hash.length) : "";
}
function $955ca6abf4bcc751$var$re(e, t) {
    if (e = $955ca6abf4bcc751$var$Q(e, "?"), t || e === "") return e;
    let r = new URL("https://example.com");
    return r.search = e, r.search ? r.search.substring(1, r.search.length) : "";
}
function $955ca6abf4bcc751$var$ne(e, t) {
    return t || e === "" ? e : $955ca6abf4bcc751$var$W(e) ? $955ca6abf4bcc751$var$j(e) : $955ca6abf4bcc751$var$z(e);
}
function $955ca6abf4bcc751$var$se(e, t) {
    if (t || e === "") return e;
    let r = new URL("https://example.com");
    return r.password = e, r.password;
}
function $955ca6abf4bcc751$var$ie(e, t) {
    if (t || e === "") return e;
    let r = new URL("https://example.com");
    return r.username = e, r.username;
}
function $955ca6abf4bcc751$var$ae(e, t, r) {
    if (r || e === "") return e;
    if (t && !$955ca6abf4bcc751$var$ee.includes(t)) return new URL(`${t}:${e}`).pathname;
    let n = e[0] == "/";
    return e = new URL(n ? e : "/-" + e, "https://example.com").pathname, n || (e = e.substring(2, e.length)), e;
}
function $955ca6abf4bcc751$var$oe(e, t, r) {
    return $955ca6abf4bcc751$var$_(t) === e && (e = ""), r || e === "" ? e : $955ca6abf4bcc751$var$K(e);
}
function $955ca6abf4bcc751$var$ce(e, t) {
    return e = $955ca6abf4bcc751$var$Ee(e, ":"), t || e === "" ? e : $955ca6abf4bcc751$var$A(e);
}
function $955ca6abf4bcc751$var$_(e) {
    switch(e){
        case "ws":
        case "http":
            return "80";
        case "wws":
        case "https":
            return "443";
        case "ftp":
            return "21";
        default:
            return "";
    }
}
function $955ca6abf4bcc751$var$A(e) {
    if (e === "") return e;
    if (/^[-+.A-Za-z0-9]*$/.test(e)) return e.toLowerCase();
    throw new TypeError(`Invalid protocol '${e}'.`);
}
function $955ca6abf4bcc751$var$le(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.username = e, t.username;
}
function $955ca6abf4bcc751$var$he(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.password = e, t.password;
}
function $955ca6abf4bcc751$var$z(e) {
    if (e === "") return e;
    if (/[\t\n\r #%/:<>?@[\]^\\|]/g.test(e)) throw new TypeError(`Invalid hostname '${e}'`);
    let t = new URL("https://example.com");
    return t.hostname = e, t.hostname;
}
function $955ca6abf4bcc751$var$j(e) {
    if (e === "") return e;
    if (/[^0-9a-fA-F[\]:]/g.test(e)) throw new TypeError(`Invalid IPv6 hostname '${e}'`);
    return e.toLowerCase();
}
function $955ca6abf4bcc751$var$K(e) {
    if (e === "" || /^[0-9]*$/.test(e) && parseInt(e) <= 65535) return e;
    throw new TypeError(`Invalid port '${e}'.`);
}
function $955ca6abf4bcc751$var$fe(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.pathname = e[0] !== "/" ? "/-" + e : e, e[0] !== "/" ? t.pathname.substring(2, t.pathname.length) : t.pathname;
}
function $955ca6abf4bcc751$var$ue(e) {
    return e === "" ? e : new URL(`data:${e}`).pathname;
}
function $955ca6abf4bcc751$var$pe(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.search = e, t.search.substring(1, t.search.length);
}
function $955ca6abf4bcc751$var$de(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.hash = e, t.hash.substring(1, t.hash.length);
}
var $955ca6abf4bcc751$var$U = class {
    #i;
    #n = [];
    #t = {};
    #e = 0;
    #s = 1;
    #u = 0;
    #c = 0;
    #p = 0;
    #d = 0;
    #g = !1;
    constructor(t){
        this.#i = t;
    }
    get result() {
        return this.#t;
    }
    parse() {
        for(this.#n = $955ca6abf4bcc751$var$v(this.#i, !0); this.#e < this.#n.length; this.#e += this.#s){
            if (this.#s = 1, this.#n[this.#e].type === "END") {
                if (this.#c === 0) {
                    this.#P(), this.#l() ? this.#r(9, 1) : this.#h() ? (this.#r(8, 1), this.#t.hash = "") : (this.#r(7, 0), this.#t.search = "", this.#t.hash = "");
                    continue;
                } else if (this.#c === 2) {
                    this.#f(5);
                    continue;
                }
                this.#r(10, 0);
                break;
            }
            if (this.#p > 0) {
                if (this.#T()) this.#p -= 1;
                else continue;
            }
            if (this.#O()) {
                this.#p += 1;
                continue;
            }
            switch(this.#c){
                case 0:
                    this.#S() && (this.#t.username = "", this.#t.password = "", this.#t.hostname = "", this.#t.port = "", this.#t.pathname = "", this.#t.search = "", this.#t.hash = "", this.#f(1));
                    break;
                case 1:
                    if (this.#S()) {
                        this.#C();
                        let t = 7, r = 1;
                        this.#g && (this.#t.pathname = "/"), this.#E() ? (t = 2, r = 3) : this.#g && (t = 2), this.#r(t, r);
                    }
                    break;
                case 2:
                    this.#x() ? this.#f(3) : (this.#b() || this.#h() || this.#l()) && this.#f(5);
                    break;
                case 3:
                    this.#R() ? this.#r(4, 1) : this.#x() && this.#r(5, 1);
                    break;
                case 4:
                    this.#x() && this.#r(5, 1);
                    break;
                case 5:
                    this.#A() ? this.#d += 1 : this.#w() && (this.#d -= 1), this.#y() && !this.#d ? this.#r(6, 1) : this.#b() ? this.#r(7, 0) : this.#h() ? this.#r(8, 1) : this.#l() && this.#r(9, 1);
                    break;
                case 6:
                    this.#b() ? this.#r(7, 0) : this.#h() ? this.#r(8, 1) : this.#l() && this.#r(9, 1);
                    break;
                case 7:
                    this.#h() ? this.#r(8, 1) : this.#l() && this.#r(9, 1);
                    break;
                case 8:
                    this.#l() && this.#r(9, 1);
                    break;
                case 9:
                    break;
                case 10:
                    break;
            }
        }
    }
    #r(t, r) {
        switch(this.#c){
            case 0:
                break;
            case 1:
                this.#t.protocol = this.#o();
                break;
            case 2:
                break;
            case 3:
                this.#t.username = this.#o();
                break;
            case 4:
                this.#t.password = this.#o();
                break;
            case 5:
                this.#t.hostname = this.#o();
                break;
            case 6:
                this.#t.port = this.#o();
                break;
            case 7:
                this.#t.pathname = this.#o();
                break;
            case 8:
                this.#t.search = this.#o();
                break;
            case 9:
                this.#t.hash = this.#o();
                break;
            case 10:
                break;
        }
        this.#k(t, r);
    }
    #k(t, r) {
        this.#c = t, this.#u = this.#e + r, this.#e += r, this.#s = 0;
    }
    #P() {
        this.#e = this.#u, this.#s = 0;
    }
    #f(t) {
        this.#P(), this.#c = t;
    }
    #m(t) {
        return t < 0 && (t = this.#n.length - t), t < this.#n.length ? this.#n[t] : this.#n[this.#n.length - 1];
    }
    #a(t, r) {
        let n = this.#m(t);
        return n.value === r && (n.type === "CHAR" || n.type === "ESCAPED_CHAR" || n.type === "INVALID_CHAR");
    }
    #S() {
        return this.#a(this.#e, ":");
    }
    #E() {
        return this.#a(this.#e + 1, "/") && this.#a(this.#e + 2, "/");
    }
    #x() {
        return this.#a(this.#e, "@");
    }
    #R() {
        return this.#a(this.#e, ":");
    }
    #y() {
        return this.#a(this.#e, ":");
    }
    #b() {
        return this.#a(this.#e, "/");
    }
    #h() {
        if (this.#a(this.#e, "?")) return !0;
        if (this.#n[this.#e].value !== "?") return !1;
        let t = this.#m(this.#e - 1);
        return t.type !== "NAME" && t.type !== "REGEX" && t.type !== "CLOSE" && t.type !== "ASTERISK";
    }
    #l() {
        return this.#a(this.#e, "#");
    }
    #O() {
        return this.#n[this.#e].type == "OPEN";
    }
    #T() {
        return this.#n[this.#e].type == "CLOSE";
    }
    #A() {
        return this.#a(this.#e, "[");
    }
    #w() {
        return this.#a(this.#e, "]");
    }
    #o() {
        let t = this.#n[this.#e], r = this.#m(this.#u).index;
        return this.#i.substring(r, t.index);
    }
    #C() {
        let t = {};
        Object.assign(t, $955ca6abf4bcc751$var$b), t.encodePart = $955ca6abf4bcc751$var$A;
        let r = $955ca6abf4bcc751$var$Z(this.#o(), void 0, t);
        this.#g = $955ca6abf4bcc751$var$N(r);
    }
};
var $955ca6abf4bcc751$var$V = [
    "protocol",
    "username",
    "password",
    "hostname",
    "port",
    "pathname",
    "search",
    "hash"
], $955ca6abf4bcc751$var$E = "*";
function $955ca6abf4bcc751$var$ge(e, t) {
    if (typeof e != "string") throw new TypeError("parameter 1 is not of type 'string'.");
    let r = new URL(e, t);
    return {
        protocol: r.protocol.substring(0, r.protocol.length - 1),
        username: r.username,
        password: r.password,
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname,
        search: r.search !== "" ? r.search.substring(1, r.search.length) : void 0,
        hash: r.hash !== "" ? r.hash.substring(1, r.hash.length) : void 0
    };
}
function $955ca6abf4bcc751$var$P(e, t) {
    return t ? $955ca6abf4bcc751$var$C(e) : e;
}
function $955ca6abf4bcc751$var$w(e, t, r) {
    let n;
    if (typeof t.baseURL == "string") try {
        n = new URL(t.baseURL), e.protocol = $955ca6abf4bcc751$var$P(n.protocol.substring(0, n.protocol.length - 1), r), e.username = $955ca6abf4bcc751$var$P(n.username, r), e.password = $955ca6abf4bcc751$var$P(n.password, r), e.hostname = $955ca6abf4bcc751$var$P(n.hostname, r), e.port = $955ca6abf4bcc751$var$P(n.port, r), e.pathname = $955ca6abf4bcc751$var$P(n.pathname, r), e.search = $955ca6abf4bcc751$var$P(n.search.substring(1, n.search.length), r), e.hash = $955ca6abf4bcc751$var$P(n.hash.substring(1, n.hash.length), r);
    } catch  {
        throw new TypeError(`invalid baseURL '${t.baseURL}'.`);
    }
    if (typeof t.protocol == "string" && (e.protocol = $955ca6abf4bcc751$var$ce(t.protocol, r)), typeof t.username == "string" && (e.username = $955ca6abf4bcc751$var$ie(t.username, r)), typeof t.password == "string" && (e.password = $955ca6abf4bcc751$var$se(t.password, r)), typeof t.hostname == "string" && (e.hostname = $955ca6abf4bcc751$var$ne(t.hostname, r)), typeof t.port == "string" && (e.port = $955ca6abf4bcc751$var$oe(t.port, e.protocol, r)), typeof t.pathname == "string") {
        if (e.pathname = t.pathname, n && !$955ca6abf4bcc751$var$J(e.pathname, r)) {
            let o = n.pathname.lastIndexOf("/");
            o >= 0 && (e.pathname = $955ca6abf4bcc751$var$P(n.pathname.substring(0, o + 1), r) + e.pathname);
        }
        e.pathname = $955ca6abf4bcc751$var$ae(e.pathname, e.protocol, r);
    }
    return typeof t.search == "string" && (e.search = $955ca6abf4bcc751$var$re(t.search, r)), typeof t.hash == "string" && (e.hash = $955ca6abf4bcc751$var$te(t.hash, r)), e;
}
function $955ca6abf4bcc751$var$C(e) {
    return e.replace(/([+*?:{}()\\])/g, "\\$1");
}
function $955ca6abf4bcc751$var$Re(e) {
    return e.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
function $955ca6abf4bcc751$var$ye(e, t) {
    t.delimiter ??= "/#?", t.prefixes ??= "./", t.sensitive ??= !1, t.strict ??= !1, t.end ??= !0, t.start ??= !0, t.endsWith = "";
    let r = ".*", n = `[^${$955ca6abf4bcc751$var$Re(t.delimiter)}]+?`, o = /[$_\u200C\u200D\p{ID_Continue}]/u, c = "";
    for(let l = 0; l < e.length; ++l){
        let s = e[l];
        if (s.type === 3) {
            if (s.modifier === 3) {
                c += $955ca6abf4bcc751$var$C(s.value);
                continue;
            }
            c += `{${$955ca6abf4bcc751$var$C(s.value)}}${$955ca6abf4bcc751$var$y(s.modifier)}`;
            continue;
        }
        let i = s.hasCustomName(), a = !!s.suffix.length || !!s.prefix.length && (s.prefix.length !== 1 || !t.prefixes.includes(s.prefix)), h = l > 0 ? e[l - 1] : null, p = l < e.length - 1 ? e[l + 1] : null;
        if (!a && i && s.type === 1 && s.modifier === 3 && p && !p.prefix.length && !p.suffix.length) {
            if (p.type === 3) {
                let O = p.value.length > 0 ? p.value[0] : "";
                a = o.test(O);
            } else a = !p.hasCustomName();
        }
        if (!a && !s.prefix.length && h && h.type === 3) {
            let O = h.value[h.value.length - 1];
            a = t.prefixes.includes(O);
        }
        a && (c += "{"), c += $955ca6abf4bcc751$var$C(s.prefix), i && (c += `:${s.name}`), s.type === 2 ? c += `(${s.value})` : s.type === 1 ? i || (c += `(${n})`) : s.type === 0 && (!i && (!h || h.type === 3 || h.modifier !== 3 || a || s.prefix !== "") ? c += "*" : c += `(${r})`), s.type === 1 && i && s.suffix.length && o.test(s.suffix[0]) && (c += "\\"), c += $955ca6abf4bcc751$var$C(s.suffix), a && (c += "}"), s.modifier !== 3 && (c += $955ca6abf4bcc751$var$y(s.modifier));
    }
    return c;
}
var $955ca6abf4bcc751$export$a348b14d2b61192c = class {
    #i;
    #n = {};
    #t = {};
    #e = {};
    #s = {};
    constructor(t = {}, r, n){
        try {
            let o;
            if (typeof r == "string" ? o = r : n = r, typeof t == "string") {
                let i = new $955ca6abf4bcc751$var$U(t);
                if (i.parse(), t = i.result, o === void 0 && typeof t.protocol != "string") throw new TypeError("A base URL must be provided for a relative constructor string.");
                t.baseURL = o;
            } else {
                if (!t || typeof t != "object") throw new TypeError("parameter 1 is not of type 'string' and cannot convert to dictionary.");
                if (o) throw new TypeError("parameter 1 is not of type 'string'.");
            }
            typeof n > "u" && (n = {
                ignoreCase: !1
            });
            let c = {
                ignoreCase: n.ignoreCase === !0
            }, l = {
                pathname: $955ca6abf4bcc751$var$E,
                protocol: $955ca6abf4bcc751$var$E,
                username: $955ca6abf4bcc751$var$E,
                password: $955ca6abf4bcc751$var$E,
                hostname: $955ca6abf4bcc751$var$E,
                port: $955ca6abf4bcc751$var$E,
                search: $955ca6abf4bcc751$var$E,
                hash: $955ca6abf4bcc751$var$E
            };
            this.#i = $955ca6abf4bcc751$var$w(l, t, !0), $955ca6abf4bcc751$var$_(this.#i.protocol) === this.#i.port && (this.#i.port = "");
            let s;
            for (s of $955ca6abf4bcc751$var$V){
                if (!(s in this.#i)) continue;
                let i = {}, a = this.#i[s];
                switch(this.#t[s] = [], s){
                    case "protocol":
                        Object.assign(i, $955ca6abf4bcc751$var$b), i.encodePart = $955ca6abf4bcc751$var$A;
                        break;
                    case "username":
                        Object.assign(i, $955ca6abf4bcc751$var$b), i.encodePart = $955ca6abf4bcc751$var$le;
                        break;
                    case "password":
                        Object.assign(i, $955ca6abf4bcc751$var$b), i.encodePart = $955ca6abf4bcc751$var$he;
                        break;
                    case "hostname":
                        Object.assign(i, $955ca6abf4bcc751$var$B), $955ca6abf4bcc751$var$W(a) ? i.encodePart = $955ca6abf4bcc751$var$j : i.encodePart = $955ca6abf4bcc751$var$z;
                        break;
                    case "port":
                        Object.assign(i, $955ca6abf4bcc751$var$b), i.encodePart = $955ca6abf4bcc751$var$K;
                        break;
                    case "pathname":
                        $955ca6abf4bcc751$var$N(this.#n.protocol) ? (Object.assign(i, $955ca6abf4bcc751$var$q, c), i.encodePart = $955ca6abf4bcc751$var$fe) : (Object.assign(i, $955ca6abf4bcc751$var$b, c), i.encodePart = $955ca6abf4bcc751$var$ue);
                        break;
                    case "search":
                        Object.assign(i, $955ca6abf4bcc751$var$b, c), i.encodePart = $955ca6abf4bcc751$var$pe;
                        break;
                    case "hash":
                        Object.assign(i, $955ca6abf4bcc751$var$b, c), i.encodePart = $955ca6abf4bcc751$var$de;
                        break;
                }
                try {
                    this.#s[s] = $955ca6abf4bcc751$var$D(a, i), this.#n[s] = $955ca6abf4bcc751$var$F(this.#s[s], this.#t[s], i), this.#e[s] = $955ca6abf4bcc751$var$ye(this.#s[s], i);
                } catch  {
                    throw new TypeError(`invalid ${s} pattern '${this.#i[s]}'.`);
                }
            }
        } catch (o) {
            throw new TypeError(`Failed to construct 'URLPattern': ${o.message}`);
        }
    }
    test(t = {}, r) {
        let n = {
            pathname: "",
            protocol: "",
            username: "",
            password: "",
            hostname: "",
            port: "",
            search: "",
            hash: ""
        };
        if (typeof t != "string" && r) throw new TypeError("parameter 1 is not of type 'string'.");
        if (typeof t > "u") return !1;
        try {
            typeof t == "object" ? n = $955ca6abf4bcc751$var$w(n, t, !1) : n = $955ca6abf4bcc751$var$w(n, $955ca6abf4bcc751$var$ge(t, r), !1);
        } catch  {
            return !1;
        }
        let o;
        for (o of $955ca6abf4bcc751$var$V)if (!this.#n[o].exec(n[o])) return !1;
        return !0;
    }
    exec(t = {}, r) {
        let n = {
            pathname: "",
            protocol: "",
            username: "",
            password: "",
            hostname: "",
            port: "",
            search: "",
            hash: ""
        };
        if (typeof t != "string" && r) throw new TypeError("parameter 1 is not of type 'string'.");
        if (typeof t > "u") return;
        try {
            typeof t == "object" ? n = $955ca6abf4bcc751$var$w(n, t, !1) : n = $955ca6abf4bcc751$var$w(n, $955ca6abf4bcc751$var$ge(t, r), !1);
        } catch  {
            return null;
        }
        let o = {};
        r ? o.inputs = [
            t,
            r
        ] : o.inputs = [
            t
        ];
        let c;
        for (c of $955ca6abf4bcc751$var$V){
            let l = this.#n[c].exec(n[c]);
            if (!l) return null;
            let s = {};
            for (let [i, a] of this.#t[c].entries())if (typeof a == "string" || typeof a == "number") {
                let h = l[i + 1];
                s[a] = h;
            }
            o[c] = {
                input: n[c] ?? "",
                groups: s
            };
        }
        return o;
    }
    static compareComponent(t, r, n) {
        let o = (i, a)=>{
            for (let h of [
                "type",
                "modifier",
                "prefix",
                "value",
                "suffix"
            ]){
                if (i[h] < a[h]) return -1;
                if (i[h] === a[h]) continue;
                return 1;
            }
            return 0;
        }, c = new $955ca6abf4bcc751$var$k(3, "", "", "", "", 3), l = new $955ca6abf4bcc751$var$k(0, "", "", "", "", 3), s = (i, a)=>{
            let h = 0;
            for(; h < Math.min(i.length, a.length); ++h){
                let p = o(i[h], a[h]);
                if (p) return p;
            }
            return i.length === a.length ? 0 : o(i[h] ?? c, a[h] ?? c);
        };
        return !r.#e[t] && !n.#e[t] ? 0 : r.#e[t] && !n.#e[t] ? s(r.#s[t], [
            l
        ]) : !r.#e[t] && n.#e[t] ? s([
            l
        ], n.#s[t]) : s(r.#s[t], n.#s[t]);
    }
    get protocol() {
        return this.#e.protocol;
    }
    get username() {
        return this.#e.username;
    }
    get password() {
        return this.#e.password;
    }
    get hostname() {
        return this.#e.hostname;
    }
    get port() {
        return this.#e.port;
    }
    get pathname() {
        return this.#e.pathname;
    }
    get search() {
        return this.#e.search;
    }
    get hash() {
        return this.#e.hash;
    }
};


if (!globalThis.URLPattern) globalThis.URLPattern = (0, $955ca6abf4bcc751$export$a348b14d2b61192c);



var $2DMbv = parcelRequire("2DMbv");

var $1Hdcz = parcelRequire("1Hdcz");

var $2LSrt = parcelRequire("2LSrt");

var $hPLup = parcelRequire("hPLup");

var $2e8RP = parcelRequire("2e8RP");

var $1u7vc = parcelRequire("1u7vc");

var $k4PPW = parcelRequire("k4PPW");

var $aJa0n = parcelRequire("aJa0n");
var $8097f422ca83d426$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $aJa0n.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 640 512",
        ...props,
        children: /*#__PURE__*/ (0, $aJa0n.jsx)("path", {
            fill: "currentColor",
            d: "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
        })
    });



var $aJa0n = parcelRequire("aJa0n");
var $10c8543a600e1e7c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $aJa0n.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aJa0n.jsx)("path", {
            fill: "currentColor",
            d: "M128 32V64H80c-26.5 0-48 21.5-48 48v48H480V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H192V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 192H32V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V192zM256 248c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V376H176c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V272c0-13.3 10.7-24 24-24z"
        })
    });



var $aJa0n = parcelRequire("aJa0n");
var $d1ddec59464d946c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $aJa0n.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aJa0n.jsx)("path", {
            fill: "currentColor",
            d: "M177.8 63.2l10 17.4c2.8 4.8 4.2 10.3 4.2 15.9v41.4c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4V318.6c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13c3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
        })
    });



var $aJa0n = parcelRequire("aJa0n");
var $f3564f0b9c5c6403$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $aJa0n.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aJa0n.jsx)("path", {
            fill: "currentColor",
            d: "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
        })
    });



var $aJa0n = parcelRequire("aJa0n");
var $2356d659d95de6b9$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $aJa0n.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aJa0n.jsx)("path", {
            fill: "currentColor",
            d: "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"
        })
    });



var $aJa0n = parcelRequire("aJa0n");
var $caf49b956ef27779$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $aJa0n.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aJa0n.jsx)("path", {
            fill: "currentColor",
            d: "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"
        })
    });



var $aJa0n = parcelRequire("aJa0n");
var $df948d2813af306f$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $aJa0n.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aJa0n.jsx)("path", {
            fill: "currentColor",
            d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3H254.8c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        })
    });



var $aJa0n = parcelRequire("aJa0n");
var $f95a38dc43529b21$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $aJa0n.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aJa0n.jsx)("path", {
            fill: "currentColor",
            d: "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"
        })
    });


window.Temporal = (0, $2DMbv.Temporal);
const $03db078888a109f1$var$browserCalendar = "iso8601";
const $03db078888a109f1$var$rtfAlways = new window.Intl.RelativeTimeFormat("en", {
    numeric: "always"
});
const $03db078888a109f1$var$rtfAuto = new window.Intl.RelativeTimeFormat("en", {
    numeric: "auto"
});
function $03db078888a109f1$var$IndexPage() {
    const [urlTZ, urlDT] = $03db078888a109f1$var$extractDataFromURL();
    const localTZ = (0, $2DMbv.Temporal).TimeZone.from((0, $2DMbv.Temporal).Now.timeZoneId());
    const isUnix = urlTZ === "unix";
    const pageTZ = isUnix ? "UTC" : urlTZ ? urlTZ : localTZ;
    const dt = (0, $hPLup.useSignal)($03db078888a109f1$var$parseTimeString(pageTZ, urlDT));
    const activeTab = $03db078888a109f1$var$activeTabSignal;
    const pageForRemoteTimeZone = isUnix || pageTZ.id !== localTZ.id;
    (0, $2LSrt.useEffect)(()=>{
        if (!urlTZ && location.pathname !== "/" && location.pathname !== "") history.replaceState(null, "", "/");
        if (!urlTZ) return;
        const timeString = isUnix ? dt.peek().epochSeconds : $03db078888a109f1$var$formatDTInput(dt.peek());
        const canonicalPathname = urlDT === "now" ? (0, $k4PPW.getPathnameFromTimezone)(isUnix ? "unix" : pageTZ) : `${(0, $k4PPW.getPathnameFromTimezone)(isUnix ? "unix" : pageTZ)}/${timeString}`;
        history.replaceState(null, "", canonicalPathname);
        $03db078888a109f1$var$updateTitle(urlDT === "now" ? undefined : dt.peek(), isUnix ? "unix" : pageTZ);
    }, []);
    const writeToLocation = (dt)=>{
        history.replaceState(null, "", `${(0, $k4PPW.getPathnameFromTimezone)(isUnix ? "unix" : pageTZ)}/${isUnix ? dt.epochSeconds : $03db078888a109f1$var$formatDTInput(dt.withTimeZone(pageTZ))}`);
        $03db078888a109f1$var$updateTitle(dt, isUnix ? "unix" : pageTZ);
    };
    return /*#__PURE__*/ (0, $aJa0n.jsxs)((0, $aJa0n.Fragment), {
        children: [
            isUnix ? /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$UnixRow, {
                rootDT: dt,
                timeZone: pageTZ,
                writeToLocation: writeToLocation
            }) : /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$ClockRow, {
                rootDT: dt,
                timeZone: pageTZ,
                withRelative: !pageForRemoteTimeZone,
                writeToLocation: writeToLocation
            }),
            pageForRemoteTimeZone ? /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$ClockRow, {
                rootDT: dt,
                timeZone: localTZ,
                withRelative: true,
                secondary: true,
                writeToLocation: writeToLocation
            }) : null,
            /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$Tabs, {
                rootDT: dt,
                pageTZ: pageTZ,
                localTZ: localTZ,
                activeTab: activeTab
            })
        ]
    });
}
const $03db078888a109f1$var$NBSP = "\xa0";
function $03db078888a109f1$var$ClockRow({ rootDT: rootDT, timeZone: timeZone, withRelative: withRelative, secondary: secondary, writeToLocation: writeToLocation }) {
    const dt = (0, $hPLup.useComputed)(()=>rootDT.value.withTimeZone(timeZone));
    const tzName = (0, $k4PPW.getLocationFromTimezone)(timeZone);
    const tzURL = new URL((0, $k4PPW.getPathnameFromTimezone)(timeZone), location.href);
    const timeInTZ = (0, $hPLup.useComputed)(()=>$03db078888a109f1$var$formatDTInput(dt.value));
    const timestampURL = (0, $hPLup.useComputed)(()=>`${tzURL}/${timeInTZ}`);
    const relative = (0, $hPLup.useSignal)($03db078888a109f1$var$NBSP);
    (0, $hPLup.useSignalEffect)(()=>{
        if (!withRelative) return;
        let timeoutId;
        function scheduleUpdateRelative() {
            timeoutId = setTimeout(()=>{
                relative.value = $03db078888a109f1$var$getRelativeTime(dt.value);
                scheduleUpdateRelative();
            }, 1000);
        }
        relative.value = $03db078888a109f1$var$getRelativeTime(dt.value);
        scheduleUpdateRelative();
        return ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        withRelative
    ]);
    const onTimeChange = (event)=>{
        try {
            const newRootDT = (0, $2DMbv.Temporal).PlainDateTime.from(event.target.value).toZonedDateTime(timeZone);
            writeToLocation(newRootDT);
            rootDT.value = newRootDT;
        } catch (e) {
            console.error(e);
            return;
        }
    };
    const onBlur = (event)=>{
        try {
            (0, $2DMbv.Temporal).PlainDateTime.from(event.target.value).toZonedDateTime(timeZone);
        } catch (_e) {
            event.target.value = $03db078888a109f1$var$formatDTInput((0, $2DMbv.Temporal).Now.zonedDateTime($03db078888a109f1$var$browserCalendar, timeZone).with({
                second: 0,
                millisecond: 0
            }));
            onTimeChange(event);
        }
    };
    return /*#__PURE__*/ (0, $aJa0n.jsxs)("div", {
        className: "clock-row",
        children: [
            secondary ? /*#__PURE__*/ (0, $aJa0n.jsx)("h2", {
                children: tzName
            }) : /*#__PURE__*/ (0, $aJa0n.jsx)("h1", {
                children: tzName
            }),
            /*#__PURE__*/ (0, $aJa0n.jsxs)("form", {
                className: "clock",
                action: "/",
                method: "GET",
                children: [
                    /*#__PURE__*/ (0, $aJa0n.jsx)("input", {
                        className: "local-time",
                        name: "t",
                        type: "datetime-local",
                        value: timeInTZ,
                        required: true,
                        onChange: onTimeChange,
                        onBlur: onBlur
                    }),
                    withRelative ? /*#__PURE__*/ (0, $aJa0n.jsx)("div", {
                        className: "relative",
                        children: relative
                    }) : null
                ]
            }),
            secondary ? null : /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$ClockRowActions, {
                timestampURL: timestampURL
            })
        ]
    });
}
function $03db078888a109f1$var$ClockRowActions({ timestampURL: timestampURL }) {
    const copyURL = navigator.clipboard ? ()=>navigator.clipboard.writeText(timestampURL.peek()) : null;
    const shareURL = navigator.share ? async ()=>{
        try {
            await navigator.share({
                url: timestampURL.peek()
            });
        } catch (_e) {
        //
        }
    } : null;
    return /*#__PURE__*/ (0, $aJa0n.jsx)((0, $aJa0n.Fragment), {
        children: /*#__PURE__*/ (0, $aJa0n.jsx)("div", {
            className: "actions",
            children: /*#__PURE__*/ (0, $aJa0n.jsxs)("div", {
                className: "scrolly",
                children: [
                    /*#__PURE__*/ (0, $aJa0n.jsx)("a", {
                        href: timestampURL,
                        "aria-label": "Link to this page",
                        children: "Link"
                    }),
                    /*#__PURE__*/ (0, $aJa0n.jsx)("div", {}),
                    /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$ActionButton, {
                        label: "Copy",
                        labelSuccess: "Copied",
                        labelFailure: "Failed",
                        action: copyURL,
                        "aria-label": "Copy Link",
                        primary: true
                    }),
                    shareURL ? /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$ActionButton, {
                        label: "Share",
                        labelSuccess: "Share",
                        labelFailure: "Share",
                        action: shareURL,
                        "aria-label": "Share Link"
                    }) : null
                ]
            })
        })
    });
}
const $03db078888a109f1$var$CALENDAR_LINKS_ID = "calendar-links";
function $03db078888a109f1$var$Tabs({ activeTab: activeTab, rootDT: rootDT, pageTZ: pageTZ, localTZ: localTZ }) {
    const otherTimezonesActive = (0, $hPLup.useComputed)(()=>activeTab.value === $03db078888a109f1$var$SAVED_TIMEZONES_ID);
    const otherTimezonesHidden = (0, $hPLup.useComputed)(()=>!otherTimezonesActive.value);
    const discordFormatsActive = (0, $hPLup.useComputed)(()=>activeTab.value === $03db078888a109f1$var$DISCORD_FORMATS_ID);
    const discordFormatsHidden = (0, $hPLup.useComputed)(()=>!discordFormatsActive.value);
    const calendarLinksActive = (0, $hPLup.useComputed)(()=>activeTab.value === $03db078888a109f1$var$CALENDAR_LINKS_ID);
    const calendarLinksHidden = (0, $hPLup.useComputed)(()=>!calendarLinksActive.value);
    return /*#__PURE__*/ (0, $aJa0n.jsxs)((0, $aJa0n.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aJa0n.jsx)("div", {
                className: "tabs-row",
                role: "tablist",
                children: /*#__PURE__*/ (0, $aJa0n.jsxs)("div", {
                    className: "scrolly",
                    children: [
                        /*#__PURE__*/ (0, $aJa0n.jsxs)("button", {
                            role: "tab",
                            "aria-selected": otherTimezonesActive,
                            onClick: ()=>{
                                activeTab.value = $03db078888a109f1$var$SAVED_TIMEZONES_ID;
                            },
                            "aria-controls": $03db078888a109f1$var$SAVED_TIMEZONES_ID,
                            "aria-labelledby": $03db078888a109f1$var$SAVED_TIMEZONES_ID,
                            children: [
                                /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$RegionAwareIcon, {
                                    timezone: pageTZ,
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $aJa0n.jsx)("span", {
                                    children: "Other timezones"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aJa0n.jsxs)("button", {
                            role: "tab",
                            "aria-selected": discordFormatsActive,
                            onClick: ()=>{
                                activeTab.value = $03db078888a109f1$var$DISCORD_FORMATS_ID;
                            },
                            "aria-controls": $03db078888a109f1$var$DISCORD_FORMATS_ID,
                            "aria-labelledby": $03db078888a109f1$var$DISCORD_FORMATS_ID,
                            children: [
                                /*#__PURE__*/ (0, $aJa0n.jsx)((0, $8097f422ca83d426$export$2e2bcd8739ae039), {
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $aJa0n.jsx)("span", {
                                    children: "Discord codes"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aJa0n.jsxs)("button", {
                            role: "tab",
                            "aria-selected": calendarLinksActive,
                            onClick: ()=>{
                                activeTab.value = $03db078888a109f1$var$CALENDAR_LINKS_ID;
                            },
                            "aria-controls": $03db078888a109f1$var$CALENDAR_LINKS_ID,
                            "aria-labelledby": $03db078888a109f1$var$CALENDAR_LINKS_ID,
                            children: [
                                /*#__PURE__*/ (0, $aJa0n.jsx)((0, $10c8543a600e1e7c$export$2e2bcd8739ae039), {
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $aJa0n.jsx)("span", {
                                    children: "Add to calendar"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$SavedTimezones, {
                rootDT: rootDT,
                pageTZ: pageTZ,
                localTZ: localTZ,
                hidden: otherTimezonesHidden
            }),
            /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$DiscordActions, {
                rootDT: rootDT,
                localTZ: localTZ,
                hidden: discordFormatsHidden
            }),
            /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$CalendarLinks, {
                rootDT: rootDT,
                localTZ: localTZ,
                hidden: calendarLinksHidden
            })
        ]
    });
}
function $03db078888a109f1$var$RegionAwareIcon({ timezone: timezone, ...otherProps }) {
    const [area] = timezone.id?.split("/") ?? [];
    /*
    > new Set(Intl.supportedValuesOf("timeZone").map(v => v.split('/')[0]))

    "Africa"
    "America"
    "Antarctica"
    "Arctic"
    "Asia"
    "Atlantic"
    "Australia"
    "Europe"
    "Indian"
    "Pacific"
    "UTC"
  */ if (area === "Europe" || area === "Atlantic") return /*#__PURE__*/ (0, $aJa0n.jsx)((0, $caf49b956ef27779$export$2e2bcd8739ae039), {
        ...otherProps
    });
    if (area === "America" || area === "Pacific") return /*#__PURE__*/ (0, $aJa0n.jsx)((0, $f3564f0b9c5c6403$export$2e2bcd8739ae039), {
        ...otherProps
    });
    if (area === "Africa") return /*#__PURE__*/ (0, $aJa0n.jsx)((0, $d1ddec59464d946c$export$2e2bcd8739ae039), {
        ...otherProps
    });
    if (area === "Australia") return /*#__PURE__*/ (0, $aJa0n.jsx)((0, $df948d2813af306f$export$2e2bcd8739ae039), {
        ...otherProps
    });
    if (area === "Asia" || area === "Indian") return /*#__PURE__*/ (0, $aJa0n.jsx)((0, $2356d659d95de6b9$export$2e2bcd8739ae039), {
        ...otherProps
    });
    // "Antarctica", "Arctic", "UTC"
    return /*#__PURE__*/ (0, $aJa0n.jsx)((0, $f95a38dc43529b21$export$2e2bcd8739ae039), {
        ...otherProps
    });
}
const $03db078888a109f1$var$DISCORD_FORMATS_ID = "discord-formats";
function $03db078888a109f1$var$DiscordActions({ rootDT: rootDT, localTZ: localTZ, hidden: hidden }) {
    const dt = (0, $hPLup.useComputed)(()=>rootDT.value.withTimeZone(localTZ));
    const timestampStyles = [
        [
            "F",
            "Long Date/Time"
        ],
        [
            "f",
            "Short Date/Time"
        ],
        // ["T", "Long Time"],
        [
            "D",
            "Long Date"
        ],
        [
            "d",
            "Short Date"
        ],
        [
            "t",
            "Short Time"
        ]
    ];
    return /*#__PURE__*/ (0, $aJa0n.jsx)("div", {
        id: $03db078888a109f1$var$DISCORD_FORMATS_ID,
        className: "discord-other-formats",
        role: "tabpanel",
        "aria-label": "Discord codes",
        hidden: hidden,
        children: timestampStyles.map(([style, name])=>{
            return /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$DiscordFormat, {
                dt: dt,
                style: style,
                name: name
            }, style);
        })
    });
}
const $03db078888a109f1$var$discordFormatter_t = new (0, $2DMbv.Intl).DateTimeFormat(undefined, {
    timeStyle: "short"
});
const $03db078888a109f1$var$discordFormatter_T = new (0, $2DMbv.Intl).DateTimeFormat(undefined, {
    timeStyle: "medium",
    timeZoneName: undefined
});
const $03db078888a109f1$var$discordFormatter_d = new (0, $2DMbv.Intl).DateTimeFormat(undefined, {
    dateStyle: "short"
});
const $03db078888a109f1$var$discordFormatter_D = new (0, $2DMbv.Intl).DateTimeFormat(undefined, {
    dateStyle: "long"
});
const $03db078888a109f1$var$discordFormatter_f = new (0, $2DMbv.Intl).DateTimeFormat(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
});
const $03db078888a109f1$var$discordFormatter_F = new (0, $2DMbv.Intl).DateTimeFormat(undefined, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
});
function $03db078888a109f1$var$DiscordFormat({ dt: dt, style: style, name: name }) {
    const code = (0, $hPLup.useComputed)(()=>`<t:${dt.value.epochSeconds}:${style}>`);
    const label = (0, $hPLup.useComputed)(()=>{
        const formatter = style === "t" ? $03db078888a109f1$var$discordFormatter_t : style === "T" ? $03db078888a109f1$var$discordFormatter_T : style === "d" ? $03db078888a109f1$var$discordFormatter_d : style === "D" ? $03db078888a109f1$var$discordFormatter_D : style === "f" ? $03db078888a109f1$var$discordFormatter_f : style === "F" ? $03db078888a109f1$var$discordFormatter_F : null;
        return formatter?.format(dt.value.toPlainDateTime());
    });
    if (!label) return null;
    return /*#__PURE__*/ (0, $aJa0n.jsxs)("div", {
        className: "discord-format",
        style: style === "F" ? {
            flexBasis: "100%",
            flexShrink: 1
        } : null,
        children: [
            /*#__PURE__*/ (0, $aJa0n.jsxs)("div", {
                className: "discord-format_row",
                children: [
                    /*#__PURE__*/ (0, $aJa0n.jsx)("span", {
                        className: "discord-format_label",
                        children: label
                    }),
                    navigator.clipboard ? /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$ActionButton, {
                        label: "Copy",
                        labelSuccess: "Copied",
                        labelFailure: "Failed",
                        action: ()=>navigator.clipboard.writeText(code.peek()),
                        "aria-label": `Copy code for ${name}`,
                        primary: true
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $aJa0n.jsx)("div", {
                className: "discord-format_row",
                children: /*#__PURE__*/ (0, $aJa0n.jsx)("span", {
                    className: "discord-format_code",
                    children: code
                })
            })
        ]
    }, style);
}
function $03db078888a109f1$var$CalendarLinks({ rootDT: rootDT, localTZ: localTZ, hidden: hidden }) {
    const dt = (0, $hPLup.useComputed)(()=>rootDT.value.withTimeZone(localTZ));
    const eventTitle = (0, $hPLup.useSignal)("");
    const eventDurationMinutes = (0, $hPLup.useSignal)(0);
    const durations = [
        [
            "None",
            0
        ],
        [
            "15m",
            15
        ],
        [
            "30m",
            30
        ],
        [
            "45m",
            45
        ],
        [
            "1h",
            60
        ],
        [
            "90m",
            90
        ],
        [
            "2h",
            120
        ],
        [
            "3h",
            180
        ]
    ];
    return /*#__PURE__*/ (0, $aJa0n.jsxs)("div", {
        id: $03db078888a109f1$var$CALENDAR_LINKS_ID,
        className: "calendar-links",
        role: "tabpanel",
        "aria-label": "Add to calendar",
        hidden: hidden,
        children: [
            /*#__PURE__*/ (0, $aJa0n.jsxs)("form", {
                className: "calendar-links-form",
                onSubmit: (event)=>event.preventDefault(),
                children: [
                    /*#__PURE__*/ (0, $aJa0n.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, $aJa0n.jsx)("span", {
                                children: "Event name"
                            }),
                            /*#__PURE__*/ (0, $aJa0n.jsx)("input", {
                                placeholder: "Event",
                                value: eventTitle,
                                onInput: (event)=>eventTitle.value = event.currentTarget.value
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aJa0n.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, $aJa0n.jsx)("span", {
                                children: "Duration"
                            }),
                            /*#__PURE__*/ (0, $aJa0n.jsx)("div", {
                                className: "calendar-links-durations",
                                role: "radiogroup",
                                "aria-label": "Duration",
                                children: durations.map(([label, duration])=>/*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$DurationButton, {
                                        label: label,
                                        duration: duration,
                                        activeDuration: eventDurationMinutes
                                    }, label))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aJa0n.jsxs)("div", {
                className: "calendar-links-rows",
                children: [
                    /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$WebcalRow, {
                        duration: eventDurationMinutes,
                        title: eventTitle,
                        dt: dt
                    }),
                    /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$GoogleCalendarRow, {
                        duration: eventDurationMinutes,
                        title: eventTitle,
                        dt: dt
                    })
                ]
            })
        ]
    });
}
function $03db078888a109f1$var$DurationButton({ label: label, duration: duration, activeDuration: activeDuration }) {
    const isActive = (0, $hPLup.useComputed)(()=>duration === activeDuration.value);
    return /*#__PURE__*/ (0, $aJa0n.jsx)("button", {
        type: "button",
        onClick: ()=>{
            activeDuration.value = duration;
        },
        role: "radio",
        "aria-checked": isActive,
        children: label
    });
}
const $03db078888a109f1$var$pad2 = (v)=>v.toString().padStart(2, "0");
const $03db078888a109f1$var$pad4 = (v)=>v.toString().padStart(4, "0");
function $03db078888a109f1$var$WebcalRow({ duration: duration, title: title, dt: dt }) {
    const href = (0, $hPLup.useComputed)(()=>{
        return "data:text/calendar;charset=utf8," + [
            "BEGIN:VCALENDAR",
            "VERSION:2.0",
            "BEGIN:VEVENT",
            `DTSTART;TZID="/${dt.value.timeZoneId}":${$03db078888a109f1$var$formatDTiCal(dt.value)}`,
            duration.value ? `DURATION;PT${duration.value}M` : "",
            `SUMMARY:${encodeURIComponent(title.value || "Event")}`,
            "END:VEVENT",
            "END:VCALENDAR"
        ].filter(Boolean).join(encodeURI("\n")) + encodeURI("\n");
    });
    return /*#__PURE__*/ (0, $aJa0n.jsx)("div", {
        className: "calendar-links-row",
        children: /*#__PURE__*/ (0, $aJa0n.jsx)("a", {
            href: href,
            children: ".ics/Webcal"
        })
    });
}
function $03db078888a109f1$var$GoogleCalendarRow({ duration: duration, title: title, dt: dt }) {
    const href = (0, $hPLup.useComputed)(()=>{
        const start = $03db078888a109f1$var$formatDTiCal(dt.value);
        const end = duration.value ? $03db078888a109f1$var$formatDTiCal(dt.value.add({
            minutes: duration.value
        })) : start;
        return "https://calendar.google.com/calendar/render?action=TEMPLATE&" + new URLSearchParams({
            text: title.value || "Event",
            ctz: dt.value.timeZoneId,
            dates: `${start}/${end}`
        }).toString();
    });
    return /*#__PURE__*/ (0, $aJa0n.jsx)("div", {
        className: "calendar-links-row",
        children: /*#__PURE__*/ (0, $aJa0n.jsx)("a", {
            href: href,
            target: "_blank",
            rel: "noreferrer",
            children: "Google Calendar"
        })
    });
}
function $03db078888a109f1$var$formatDTiCal(dt) {
    const { isoYear: isoYear, isoMonth: isoMonth, isoDay: isoDay, isoHour: isoHour, isoMinute: isoMinute, isoSecond: isoSecond } = dt.getISOFields();
    return `${$03db078888a109f1$var$pad4(isoYear)}${$03db078888a109f1$var$pad2(isoMonth)}${$03db078888a109f1$var$pad2(isoDay)}T${$03db078888a109f1$var$pad2(isoHour)}${$03db078888a109f1$var$pad2(isoMinute)}${$03db078888a109f1$var$pad2(isoSecond)}`;
}
function $03db078888a109f1$var$ActionButton({ label: label, labelSuccess: labelSuccess, labelFailure: labelFailure, action: action, primary: primary, "aria-label": ariaLabel }) {
    const labelSignal = (0, $hPLup.useSignal)(label);
    const timeoutIdSignal = (0, $hPLup.useSignal)(undefined);
    const onClick = action ? async ()=>{
        clearTimeout(timeoutIdSignal.peek());
        try {
            await action();
            (0, $hPLup.batch)(()=>{
                labelSignal.value = labelSuccess;
                timeoutIdSignal.value = setTimeout(()=>{
                    labelSignal.value = label;
                }, 1000);
            });
        } catch (_e) {
            (0, $hPLup.batch)(()=>{
                labelSignal.value = labelFailure;
                timeoutIdSignal.value = setTimeout(()=>{
                    labelSignal.value = label;
                }, 1000);
            });
        }
    } : null;
    return /*#__PURE__*/ (0, $aJa0n.jsx)("button", {
        disabled: !action,
        onClick: onClick,
        className: primary ? "primary" : null,
        "aria-label": ariaLabel,
        children: labelSignal
    });
}
function $03db078888a109f1$var$UnixRow({ rootDT: rootDT, writeToLocation: writeToLocation }) {
    const timeInUnix = (0, $hPLup.useComputed)(()=>rootDT.value.epochSeconds);
    const timestampURL = (0, $hPLup.useComputed)(()=>new URL(`/unix/${timeInUnix}`, location.href).toString());
    const onTimeChange = (event)=>{
        if (!event.target.value || !event.target.value.match(/^[0-9]{1,10}$/)) return;
        try {
            const newRootDT = (0, $2DMbv.Temporal).PlainDateTime.from(new Date(+event.target.value * 1000).toISOString().replace(/Z$/, "")).toZonedDateTime("UTC");
            writeToLocation(newRootDT, true);
            rootDT.value = newRootDT;
        } catch (e) {
            console.error(e);
            return;
        }
    };
    const onBlur = (event)=>{
        if (!event.target.value || !event.target.value.match(/^[0-9]{1,10}$/)) {
            event.target.value = Math.floor(+new Date() / 1000).toString();
            onTimeChange(event);
        }
    };
    return /*#__PURE__*/ (0, $aJa0n.jsxs)("div", {
        className: "clock-row",
        children: [
            /*#__PURE__*/ (0, $aJa0n.jsx)("h1", {
                children: "Unix Epoch"
            }),
            /*#__PURE__*/ (0, $aJa0n.jsx)("form", {
                className: "clock",
                action: "/",
                method: "GET",
                children: /*#__PURE__*/ (0, $aJa0n.jsx)("input", {
                    className: "unix-input",
                    name: "t",
                    type: "text",
                    maxLength: "10",
                    pattern: "^[0-9]+$",
                    value: timeInUnix,
                    required: true,
                    onChange: onTimeChange,
                    onInput: onTimeChange,
                    onBlur: onBlur,
                    autoComplete: "off"
                })
            }),
            /*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$ClockRowActions, {
                timestampURL: timestampURL
            })
        ]
    });
}
const $03db078888a109f1$var$shortDateFormatter = new (0, $2DMbv.Intl).DateTimeFormat(undefined, {
    day: "numeric",
    month: "short"
});
const $03db078888a109f1$var$shortTimeFormatter = new (0, $2DMbv.Intl).DateTimeFormat(undefined, {
    timeStyle: "short"
});
const $03db078888a109f1$var$SAVED_TIMEZONES_ID = "saved-timezones";
function $03db078888a109f1$var$SavedTimezones({ rootDT: rootDT, pageTZ: pageTZ, localTZ: localTZ, hidden: hidden }) {
    const timezones = (0, $hPLup.useSignal)([]);
    const pageDateString = (0, $hPLup.useComputed)(()=>$03db078888a109f1$var$shortDateFormatter.format(rootDT.value.withTimeZone(pageTZ).toPlainDateTime()));
    const localDateString = (0, $hPLup.useComputed)(()=>$03db078888a109f1$var$shortDateFormatter.format(rootDT.value.withTimeZone(pageTZ).toPlainDateTime()));
    (0, $2LSrt.useEffect)(()=>{
        (0, $2e8RP.loadSettings)().then((settings)=>{
            timezones.value = settings.timezones;
        });
    }, []);
    const filteredTimezones = (0, $hPLup.useComputed)(()=>{
        return timezones.value.filter(({ timezone: timezone, label: label })=>timezone !== localTZ.id && timezone !== pageTZ.id || label);
    });
    const settingsLabel = (0, $hPLup.useComputed)(()=>filteredTimezones.value.length ? "Edit" : "Add a timezone");
    return /*#__PURE__*/ (0, $aJa0n.jsxs)("div", {
        id: $03db078888a109f1$var$SAVED_TIMEZONES_ID,
        role: "tabpanel",
        "aria-label": "Other timezones",
        hidden: hidden,
        children: [
            filteredTimezones.value.map(({ timezone: timezone, label: label })=>{
                const plainDateTime = rootDT.value.withTimeZone((0, $2DMbv.Temporal).TimeZone.from(timezone)).toPlainDateTime();
                const dateString = $03db078888a109f1$var$shortDateFormatter.format(plainDateTime);
                const timeString = $03db078888a109f1$var$shortTimeFormatter.format(plainDateTime);
                return /*#__PURE__*/ (0, $aJa0n.jsxs)("div", {
                    role: "listitem",
                    className: "timezone-row",
                    children: [
                        /*#__PURE__*/ (0, $aJa0n.jsx)("a", {
                            className: "timezone-label",
                            href: new URL((0, $k4PPW.getPathnameFromTimezone)(timezone), location.href),
                            children: label ? `${label} (${(0, $k4PPW.getLocationFromTimezone)(timezone)})` : (0, $k4PPW.getLocationFromTimezone)(timezone)
                        }),
                        /*#__PURE__*/ (0, $aJa0n.jsx)("div", {
                            children: localDateString.value === dateString && pageDateString.value === dateString ? timeString : `${dateString}, ${timeString}`
                        })
                    ]
                }, timezone + ":" + label);
            }),
            /*#__PURE__*/ (0, $aJa0n.jsxs)("div", {
                className: "footer",
                children: [
                    /*#__PURE__*/ (0, $aJa0n.jsx)("div", {}),
                    /*#__PURE__*/ (0, $aJa0n.jsx)("a", {
                        href: "/settings",
                        children: settingsLabel
                    })
                ]
            })
        ]
    });
}
function $03db078888a109f1$var$parseTimeString(timezone, timeString) {
    if (timezone === "unix") timezone = "UTC";
    let date = undefined;
    try {
        date = (0, $2DMbv.Temporal).PlainDate.from(timeString);
    } catch (_e) {
        date = (0, $2DMbv.Temporal).Now.plainDate($03db078888a109f1$var$browserCalendar);
    }
    if (timeString && timeString !== "now") try {
        (0, $2DMbv.Temporal).PlainTime.from(timeString);
    } catch (_e) {
        timeString = "now";
    }
    return !timeString || timeString === "now" ? (0, $2DMbv.Temporal).Now.zonedDateTime($03db078888a109f1$var$browserCalendar, timezone).with({
        second: 0,
        millisecond: 0
    }) : date.toZonedDateTime({
        plainTime: (0, $2DMbv.Temporal).PlainTime.from(timeString),
        timeZone: timezone
    });
}
function $03db078888a109f1$var$extractDataFromURL() {
    const unixURLPattern = new URLPattern({
        pathname: "/unix{/:seconds(\\d*)}?"
    }, {
        ignoreCase: true
    });
    const matchesUnix = unixURLPattern.test(location.href);
    if (matchesUnix) {
        const { seconds: seconds } = unixURLPattern.exec(location.href).pathname.groups;
        if (!seconds || !seconds.match(/^[0-9]{1,10}$/)) return [
            "unix",
            "now"
        ];
        return [
            "unix",
            new Date(+seconds * 1000).toISOString().replace(/Z$/, "")
        ];
    }
    const geoURLPattern = new URLPattern({
        pathname: "/:zeroth{/*}?"
    });
    const matchesGeo = geoURLPattern.test(location.href);
    if (!matchesGeo) return [];
    const { zeroth: zeroth, 0: extra } = geoURLPattern.exec(location.href).pathname.groups;
    if (zeroth === "") return [];
    const [first, second, third] = extra?.split("/") ?? [];
    let remoteTZ = (0, $1u7vc.guessTimezone)(`${zeroth}/${first}/${second}`, {
        strict: true
    });
    if (remoteTZ) return [
        remoteTZ,
        third ?? "now"
    ];
    remoteTZ = (0, $1u7vc.guessTimezone)(`${zeroth}/${first}`, {
        strict: true
    });
    if (remoteTZ) return [
        remoteTZ,
        second ?? "now"
    ];
    remoteTZ = (0, $1u7vc.guessTimezone)(`${zeroth}`, {
        strict: true
    });
    if (remoteTZ) return [
        remoteTZ,
        first ?? "now"
    ];
    return [];
}
const $03db078888a109f1$var$weekdayFormatter = new (0, $2DMbv.Intl).DateTimeFormat("en", {
    weekday: "long"
});
function $03db078888a109f1$var$getRelativeTime(dt) {
    const localDateTime = dt;
    const now = (0, $2DMbv.Temporal).Now.zonedDateTime($03db078888a109f1$var$browserCalendar, dt.timeZone);
    const today = now.startOfDay();
    const durationSinceNow = localDateTime.since(now);
    const durationSinceToday = localDateTime.startOfDay().since(today);
    const inTheFuture = (0, $2DMbv.Temporal).ZonedDateTime.compare(localDateTime, now) === 1;
    const thisMinute = !inTheFuture && -1 * durationSinceNow.total("second") < 60;
    if (thisMinute) return "now";
    const totalSeconds = durationSinceNow.total("second");
    const totalMinutes = durationSinceNow.total("minute");
    const totalHours = durationSinceNow.total("hour");
    const totalDays = localDateTime.startOfDay().since(today, {
        largestUnit: "day",
        roundingMode: "floor"
    }).total("day");
    const totalWeeks = localDateTime.startOfDay().since(today, {
        largestUnit: "day",
        roundingMode: "floor"
    }).total({
        unit: "week",
        relativeTo: today
    });
    const totalMonths = durationSinceToday.total({
        unit: "month",
        relativeTo: today
    });
    const totalYears = durationSinceToday.total({
        unit: "year",
        relativeTo: today
    });
    if (0 < totalSeconds && totalSeconds < 60) return $03db078888a109f1$var$rtfAuto.format(Math.ceil(totalSeconds), "second");
    if (Math.ceil(Math.abs(totalMinutes)) < 120) return $03db078888a109f1$var$rtfAuto.format(Math.ceil(totalMinutes), "minute");
    if (Math.floor(Math.abs(totalDays)) === 0 || Math.ceil(Math.abs(totalHours)) < 12) return $03db078888a109f1$var$rtfAuto.format(Math.floor(totalHours), "hour");
    if (Math.abs(totalDays) < 2) return $03db078888a109f1$var$rtfAuto.format(Math.floor(totalDays), "day");
    if (Math.abs(totalDays) < 7) return `${totalDays < 0 ? "past" : "upcoming"} ${$03db078888a109f1$var$weekdayFormatter.format(localDateTime.toPlainDate())}`;
    if (Math.abs(totalMonths) < 1) return $03db078888a109f1$var$rtfAlways.format(Math.trunc(totalWeeks), "week");
    if (Math.abs(totalYears) < 1) return $03db078888a109f1$var$rtfAlways.format(Math.trunc(totalMonths), "months");
    return $03db078888a109f1$var$rtfAlways.format(Math.trunc(totalYears), "year");
}
function $03db078888a109f1$var$formatDTInput(dt) {
    return dt.toPlainDateTime().toString({
        smallestUnit: "minute",
        calendarName: "never"
    });
}
// function formatDTDisplay(dt) {
//   return dt.toPlainDateTime().toLocaleString(undefined, {
//     dateStyle: "medium",
//     timeStyle: "short",
//   });
// }
const $03db078888a109f1$var$titleFormatter = new (0, $2DMbv.Intl).DateTimeFormat(undefined, {
    dateStyle: "long",
    timeStyle: "short"
});
function $03db078888a109f1$var$formatDTTitle(dt) {
    return $03db078888a109f1$var$titleFormatter.format(dt.toPlainDateTime());
}
function $03db078888a109f1$var$updateTitle(dt, tz) {
    if (!dt && !tz) {
        document.title = `when.st`;
        return;
    }
    const placeStr = (0, $k4PPW.getLocationFromTimezone)(tz);
    if (!dt) {
        document.title = tz === "unix" ? `Unix epoch | when.st` : `Time in ${placeStr} | when.st`;
        return;
    }
    if (tz === "unix") {
        document.title = `Unix ${dt.epochSeconds} | when.st`;
        return;
    }
    const timeStr = $03db078888a109f1$var$formatDTTitle(dt);
    document.title = `${timeStr} in ${placeStr} | when.st`;
}
const $03db078888a109f1$var$activeTabSignal = (0, $hPLup.signal)(history.state?.activeTab === $03db078888a109f1$var$SAVED_TIMEZONES_ID || history.state?.activeTab === $03db078888a109f1$var$DISCORD_FORMATS_ID || history.state?.activeTab === $03db078888a109f1$var$CALENDAR_LINKS_ID ? history.state.activeTab : $03db078888a109f1$var$SAVED_TIMEZONES_ID);
(0, $hPLup.effect)(()=>{
    if ($03db078888a109f1$var$activeTabSignal.value !== history.state?.activeTab) history.replaceState({
        ...history.state,
        activeTab: $03db078888a109f1$var$activeTabSignal.value
    }, undefined);
});
(0, $1Hdcz.render)(/*#__PURE__*/ (0, $aJa0n.jsx)($03db078888a109f1$var$IndexPage, {}), document.querySelector("main"));


//# sourceMappingURL=index.ab7339c8.js.map
